// 房源重新发起时使用的逻辑
/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-02-12 09:22:36
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-04-27 23:07:13
 * @FilePath: \szsc_ipark_device_admin(contractadmin)\src\index-page\api\workflow.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '@/api/base'

let str = '/dcits-integration'

// 校验当前六次是否为最新流程接口_用于重新发起时校验
const deleteFun = (params) => {
  return http.post(str + '/roomInfo/clearRoomProcInst?defId=', params)
}

const getList = (procInstId) => {
  return http.get(str + '/roomInfo/getRoomInfo?processInstanceId=' + procInstId)
}

export default {
  deleteFun,
  getList
}



// WEBPACK FOOTER //
// ./src/area-index-page/api/roomFun.js